/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ContactData } from './ContactData';
import {
    ContactDataFromJSON,
    ContactDataFromJSONTyped,
    ContactDataToJSON,
} from './ContactData';

/**
 * 
 * @export
 * @interface ManufacturerDto
 */
export interface ManufacturerDto {
    /**
     * 
     * @type {string}
     * @memberof ManufacturerDto
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturerDto
     */
    readonly fullName: string;
    /**
     * 
     * @type {ContactData}
     * @memberof ManufacturerDto
     */
    contactData: ContactData;
    /**
     * 
     * @type {string}
     * @memberof ManufacturerDto
     */
    readonly icon: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturerDto
     */
    $type?: ManufacturerDtoTypeEnum;
}


/**
 * @export
 */
export const ManufacturerDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedSystemComponentDtoManufacturerDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.SystemComponent.Dto.ManufacturerDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManufacturerDtoTypeEnum = typeof ManufacturerDtoTypeEnum[keyof typeof ManufacturerDtoTypeEnum];



/**
 * Check if a given object implements the ManufacturerDto interface.
 */
export function instanceOfManufacturerDto(value?: unknown): value is ManufacturerDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManufacturerDtoTypeEnum)[0];
}

export function ManufacturerDtoFromJSON(json: any): ManufacturerDto {
    return ManufacturerDtoFromJSONTyped(json, false);
}

export function ManufacturerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManufacturerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'fullName': json['fullName'],
        'contactData': ContactDataFromJSON(json['contactData']),
        'icon': json['icon'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ManufacturerDtoToJSON(value?: Omit<ManufacturerDto, 'name'|'fullName'|'icon'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'contactData': ContactDataToJSON(value['contactData']),
        '$type': value['$type'],
    });
}

